var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emptyPlaceholder"},[_c('img',{staticClass:"imgInfo",attrs:{"src":require("@/assets/empty-icon-green.svg")}}),_c('img',{staticClass:"imgWarning",attrs:{"src":require("@/assets/empty-icon-red.svg")}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }